export const UnitDefectTypes = [
	{
		name: "Broken",
		value: "Broken"
	},
	{
		name: "Scratched",
		value: "Scratched"
	},
	{
		name: "Opening Problems",
		value: "Opening Problems"
	}
];

export const GlassDefectTypes = [
	{
		name: "Broken",
		value: "Broken"
	},
	{
		name: "Damaged",
		value: "Damaged"
	},
	{
		name: "Stained",
		value: "Stained"
	}
];

export const FittingDefectTypes = [
	{
		name: "Damaged",
		value: "Damaged"
	},
	{
		name: "Lack",
		value: "Lack"
	},
	{
		name: "Incorrect",
		value: "Incorrect"
	}
];

export const AccessoriesDefectTypes = [
	{
		name: "Damaged",
		value: "Damaged"
	},
	{
		name: "Lack",
		value: "Lack"
	},
	{
		name: "Incorrect",
		value: "Incorrect"
	},
	{
		name: "Wrong Sprosses",
		value: "Wrong Sprosses"
	},
	{
		name: "Wrong Glass Lists",
		value: "Wrong Glass Lists"
	}
];

export const DefectNoticeLoactions = [
	{
		name: "On Pallet",
		value: "On Pallet"
	},
	{
		name: "After Unpacking",
		value: "After Unpacking"
	},
	{
		name: "After Mounting",
		value: "After Mounting"
	},
]

export const GlassLocations = [
	{
		name: "Inside",
		value: "Inside"
	},
	{
		name: "Middle",
		value: "Middle"
	},
	{
		name: "Outside",
		value: "Outside"
	},
]